import axios from "axios";
import { BASE_URL, axiosInstanceConfig } from "./apiService";







const header1 = {
  'Content-Type': 'application/json',
  "Access-Control-Allow-Credentials": "true",
  "X-Requested-With": "XMLHttpRequest",
  "Cache-Control": "no-cache",
  "Session": ""
}

const header2 = {
  'accept': "*/*"
}

/** Axios create for query with token */
export const apiQueryWithToken = axiosInstanceConfig(
  axios.create({
    baseURL: BASE_URL,
    headers: header1
  })
);

/** Axios create for query with token */
export const apiQueryWithTokenRegional = axiosInstanceConfig(
  axios.create({
    baseURL: "",
    headers: header1
  })
);

/** Axios create for query without token */
export const apiQueryToUploadData = axiosInstanceConfig(
  axios.create({
    baseURL: BASE_URL,
    headers: header2
  })
);

/** Axios create for query without token */
export const apiQueryToUploadDataRegional = axiosInstanceConfig(
  axios.create({
    baseURL: "",
    headers: header2
  })
);

/** Axios create for query without token */
export const apiQueryToDownloadData = axiosInstanceConfig(
  axios.create({
    baseURL: "",
    headers: header2
  })
);

/** Axios create for query without token */
export const apiQueryToViewFile = axiosInstanceConfig(
    axios.create({
        baseURL: "",
        headers: header2
    })
);
